import { useQuery } from '@tanstack/react-query';
import { useUserStore, selectIsSessionValid } from '../store/userStore';
import { userProfileApi } from '../services/userProfileApi';

export const userProfileQueryKey = (token: string | null) => ['userProfile', token ?? ''] as const;

export function useProfile() {
  const token = useUserStore((state) => state.token);
  const isAuthed = useUserStore(selectIsSessionValid);

  return useQuery({
    queryKey: userProfileQueryKey(token),
    queryFn: () => userProfileApi.getMe(token!),
    enabled: isAuthed && !!token,
    staleTime: 60_000,
  });
}
